export default function PageNotFound() {
    return (
        <>
            <h1>404 Error</h1>
            <h2>{{ de: "Die Seite wurde nicht gefunden.", en: "Page Not Found" }[global.language]}</h2>
        </>
    );
}
